import RemoveIcon from "../../../../../components/RemoveIcon";

const RemoveButton = ({ onClick }) => {
	return <RemoveIcon onClick={onClick} />;
};

export default RemoveButton;
